import React from 'react';
import {PanoramaRenderer} from '../rendering/PanoramaRenderer.jsx';
import {memo} from '../utils/PanoramaUtilsReact.jsx';


export const PanoramaLoaderVariationsParser = memo(({src = undefined, styleIndex:givenStyleIndex = undefined, locationIndex:givenLocationIndex = undefined, ...props}) =>
{
	return (<>
		<PanoramaRenderer {...props}/>
	</>);
});
